const sortAscending = (options) => {
    return options.sort((a, b) => {
        return (a[1] < b[1]) ? -1 : 1
    })
}

export default sortAscending
